// frontend/src/pages/PayrollDrafts/usePayRuns.ts
// React Query hook for the pay-runs list.

import { useQuery } from "@tanstack/react-query";
import apiFetch from "../../utils/apiFetch";
import { authHeaders } from "./helpers";
import type { PayRun } from "./types";

/**
 * Fetches all payroll runs (both drafts and finalized).
 * Falls back to an empty array if the response is not an array.
 */
export function usePayRuns() {
  return useQuery<PayRun[]>({
    queryKey: ["payroll-runs"],
    queryFn: async function () {
      const res = await apiFetch("/api/v1/payroll/runs", {
        headers: authHeaders(),
      });
      if (!res.ok) throw new Error("Could not load pay runs");
      const data = await res.json();
      return Array.isArray(data) ? data : [];
    },
    refetchOnWindowFocus: false,
  });
}